import {useQuery} from "@tanstack/react-query";

import {getServiceQueryOptions} from "./get-service.query-options";

export function useGetService(id: string, includeDeleted = false) {
  return useQuery(getServiceQueryOptions(id, includeDeleted));
}
